import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    fontSize: '12px !important',
    '& .MuiDataGrid-columnSeparator': {
      color: '#E3E7E8',
      visibility: 'visible !important',
      height: '100%',
    },
    '& .Mui-selected': {
      backgroundColor: 'rgba(156, 39, 176, 0.08) !important',
    },
    '& .MuiDataGrid-columnHeader:focus-within': {
      outline: 'solid #9c27b0 1px !important',
    },
    '& .MuiDataGrid-cell:focus': {
      outline: 'solid #9c27b0 1px !important',
    },
  },
  rootDark: {
    color: 'white !important',
    borderColor: 'rgba(81, 81, 81, 1) !important',
    fontSize: '12px !important',
    '& .MuiDataGrid-columnSeparator': {
      color: '#3E3E3E !important',
      visibility: 'visible !important',
      height: '100%',
    },
    '& .Mui-selected': {
      backgroundColor: 'rgba(156, 39, 176, 0.08) !important',
    },
    '& .MuiDataGrid-columnHeader:focus-within': {
      outline: 'solid #9c27b0 1px !important',
    },
    '& .MuiDataGrid-cell': {
      borderBottom: '1px solid rgba(81, 81, 81, 1) !important',
    },
    '& .MuiDataGrid-cell:focus': {
      outline: 'solid #9c27b0 1px !important',
    },
    '& .MuiTablePagination-root': {
      color: 'white !important',
    },
    '& .MuiTablePagination-selectIcon': {
      color: 'white !important',
    },
    '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {
      backgroundColor: '#202022',
    },
    '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-corner': {
      backgroundColor: '#202022',
    },
    '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb': {
      border: '3px solid #202022',
      minHeight: '24px',
      borderRadius: '8px',
      backgroundColor: '#585859',
    },
    '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb:hover': {
      backgroundColor: '#838384',
    },
    '& .MuiDataGrid-footerContainer': {
      borderTopStyle: 'none !important',
    },
    '& .MuiDataGrid-columnHeaders': {
      borderBottomStyle: 'none !important',
    },
  },
});

const DataTable = props => {
  const theme = useTheme();
  const classes = useStyles();
  const { data, unread = [], columns, getRowClassName, defaultRowClassName } = props;

  return (
    <DataGrid
      className={theme.palette.type === 'dark' ? classes.rootDark : classes.root}
      rows={data || []}
      columns={columns}
      pagination
      initialState={{
        ...data.initialState,
        pagination: { paginationModel: { pageSize: 10 } },
      }}
      disableColumnMenu
      pageSizeOptions={[10, 20, 50, 100]}
      getRowClassName={params => (defaultRowClassName ? '' : getRowClassName(params.id, unread))}
    />
  );
};

const propTypes = {
  data: PropTypes.object.isRequired,
  columns: PropTypes.array.isRequired,
  defaultRowClassName: PropTypes.bool,
  unread: PropTypes.array,
  getRowClassName: PropTypes.func,
};

const defaultProps = {
  unread: [],
  defaultRowClassName: true,
  getRowClassName: () => {},
};

DataTable.propTypes = propTypes;
DataTable.defaultProps = defaultProps;

export default DataTable;
